import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import { useLocation } from '@xing-com/crate-core-router';

import { messages } from './messages';

const titleMap: Record<string, string> = {
  '/start/signup': 'CRATE_REGISTRATION_PAGE_TITLE',
  '/deactivated': 'CRATE_DEACTIVATED_PAGE_TITLE',
  '/reactivation': 'CRATE_REACTIVATION_PAGE_TITLE',
  '/recovery': 'CRATE_RECOVERY_PASSWORD_PAGE_TITLE',
  '/recovery/account/no-access': 'CRATE_RECOVERY_NO_ACCESS_PAGE_TITLE',
  '/security-check': 'CRATE_SECURITY_CHECK_PAGE_TITLE',
};

export const HtmlHead: React.FC = () => {
  const intl = useIntl();
  const location = useLocation();
  const title =
    titleMap[location.pathname.replace('/xingternal', '')] ||
    'LOGIN_FRONTEND_META_TITLE';

  return (
    <Helmet
      title={intl.formatMessage({
        id: title,
      })}
      meta={[
        {
          name: 'description',
          content: intl.formatMessage(messages.metaDescription),
        },
      ]}
      link={[
        {
          rel: 'shortcut icon',
          href: 'https://www.xing.com/assets/frontend_minified/img/shared/xing_r1.ico',
          type: 'image/ico',
        },
        {
          rel: 'apple-touch-icon',
          href: 'https://www.xing.com/assets/frontend_minified/img/shared/xing_icon_apple.png',
        },
      ]}
    />
  );
};
